import { createContext, use } from 'react'
import { getSubdomainFromHost } from './organization'

export interface Config {
    basename?: string
    auth0Domain: string
    auth0ClientId: string
    auth0Audience?: string
    auth0Scope?: string
    subdomain?: string
    audienceServiceUrl: string
    aguiServiceUrl: string
    copilotkitRuntimeUrl: string
}

const defaultConfig: Config = {
    // for BrowserRouter - A properly formatted basename should have a leading slash, but no trailing slash.
    // '/' is not valid use undefined
    basename: undefined,

    auth0Domain: '',
    auth0ClientId: '',
    audienceServiceUrl: 'http://localhost:8000',
    aguiServiceUrl: 'http://localhost:8000/agui',
    copilotkitRuntimeUrl: 'http://localhost:4000/copilotkit',
}

// Runtime fetch - file can exist or not.
// Won't exist on precommit since overrideConfig.json is gitignored.
const fetchOverrideConfig: Promise<Partial<Config>> = fetch(
    '/overrideConfig.json'
)
    .then((response) => {
        if (!response.ok) {
            console.info('No overrideConfig.json found, using defaults')
            return {}
        }
        return response.json()
    })
    .catch(() => ({}))

export const configPromise: Promise<Config> = fetchOverrideConfig.then(
    (overrideConfig) => ({
        ...defaultConfig,
        ...overrideConfig,
        subdomain: getSubdomainFromHost(),
    })
)

export const ConfigContext = createContext(defaultConfig)

export const useConfig = () => use(ConfigContext)
